import React from 'react';
import { useTranslation } from 'react-i18next';
import { Building2, Settings2, MessageSquare, Mail, Users } from 'lucide-react';
import { isQuoteDistributionUiEnabled } from '../../utils/featureFlags';

const TABS = [
  {
    key: 'store-profile',
    labelKey: 'settings.tabs.storeProfileLabel',
    descKey: 'settings.tabs.storeProfileDesc',
    Icon: Building2,
  },
  {
    key: 'basic-setup',
    labelKey: 'settings.tabs.basicSetupLabel',
    descKey: 'settings.tabs.basicSetupDesc',
    Icon: Settings2,
  },
  {
    key: 'customer-interface',
    labelKey: 'settings.tabs.customerInterfaceLabel',
    descKey: 'settings.tabs.customerInterfaceDesc',
    Icon: MessageSquare,
  },
  {
    key: 'email',
    labelKey: 'settings.tabs.emailLabel',
    descKey: 'settings.tabs.emailDesc',
    Icon: Mail,
  },
  {
    key: 'distribution',
    labelKey: 'settings.tabs.distributionLabel',
    descKey: 'settings.tabs.distributionDesc',
    Icon: Users,
    hidden: !isQuoteDistributionUiEnabled(),
  },
];

/**
 * Horizontal icon card tabs matching Settings screenshots.
 */
const SettingsTabBar = ({ activeKey, onSelect }) => {
  const { t } = useTranslation();
  return (
    <div className="q2c-settings-tabs mb-4">
      {TABS.filter((tab) => !tab.hidden).map(({ key, labelKey, descKey, Icon }) => {
        const active = activeKey === key;
        return (
          <button
            key={key}
            type="button"
            className={`q2c-settings-tab${active ? ' is-active' : ''}`}
            onClick={() => onSelect(key)}
          >
            <span className="q2c-settings-tab-icon">
              <Icon size={20} strokeWidth={2} />
            </span>
            <span className="q2c-settings-tab-text">
              <span className="q2c-settings-tab-label">{t(labelKey)}</span>
              <span className="q2c-settings-tab-desc">{t(descKey)}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default SettingsTabBar;
export { TABS };
